/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'facebook': {
    width: 500,
    height: 500,
    viewBox: '0 0 500 500',
    data: '<path pid="0" _fill="#1B1625" fill-rule="evenodd" d="M70.11 39h358.711c17.195 0 31.229 13.567 31.229 30.292V429.64c0 16.842-14.034 30.41-31.11 30.41H328.472V314.3h40.936l11.695-54.654h-52.631V223.21c-2.776-15.436 1.568-26.512 23.392-24.291h29.24v-54.656c-3.109.96-10.959.715-21.07.4-5.997-.187-12.794-.4-19.867-.4-42.036 0-70.287 26.161-70.174 72.875v42.51h-46.784V314.3h46.784V460.05H70.11C52.918 460.05 39 446.482 39 429.64V69.292C39 52.567 52.918 39 70.11 39z"/>'
  }
})
